// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const ADMIN_LOADED = "ADMIN_LOADED";
export const AUTH_FAIL = "AUTH_FAIL";
export const GET_TRANSITION="GET_TRANSITION";
export const GET_TRANSITION_TASK="GET_TRANSITION_TASK";
export const GET_TRANSITION_PROGRESS="GET_TRANSITION_PROGRESS";
export const GET_CMS ="GET_CMS";
export const GET_CMS_List="GET_CMS_List";
export const GET_SETTINGS="GET_SETTINGS"
